/**
 * round to tens hundreds or a precision in decimals, to round to decimal precisions you must use negative numbers
 * @param {*} num 
 * @param {*} exp 1 = tens, 2 = hundreds, -2 just 2 decimals
 * @returns 
 * ```js
let numeros = [28320.538, 31860.426, 57820.613, 38940.297];
numeros.map((n) => console.log(n + ' > ' + roundExp(n, -2)));
// 28320.538 > 28300
// 31860.426 > 31900
// 57820.613 > 57800
// 38940.297 > 38900
numeros.map((n) => console.log(n + ' > ' + roundExp(n, 2)));
// 28320.538 > 28320.54
// 31860.426 > 31860.43
// 57820.613 > 57820.61
// 38940.297 > 38940.3
 * ```
 */
export function roundExp(num, exp, roundFun = Math.round) {
  let pow = Math.pow(10, Math.abs(exp));
  return exp <= 0 ? roundFun(num * pow) / pow : roundFun(num / pow) * pow;
}
/**
 *
 */
